import { render, staticRenderFns } from "./MigracionOrdenesCompra.vue?vue&type=template&id=0199dd21"
import script from "./MigracionOrdenesCompra.vue?vue&type=script&lang=js"
export * from "./MigracionOrdenesCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports